import React from 'react';
import classnames from 'classnames';
import { ListItem } from '@eb/eds-list-item';
import { Icon } from '@eb/eds-icon';
import { Badge } from '@eb/eds-badge';
import { Button } from '@eb/eds-button';

import { CheckChunky } from '@eb/eds-iconography';
import { ArrowRight } from '@eb/eds-iconography';

import {
    FEATURE_UNLIMITED_TICKET_TYPES,
    NEW_TAG_TEXT,
} from '../../constants/main';

const DEFAULT_ICON_COLOR = 'ui-orange';
const BOLD_TEXT_CLASS = 'eds-text-hs eds-text-bm eds-text-weight--heavy';
const DEFAULT_TEXT_COLOR = 'grey-600';
const FEATURE_INFO_SECTION_CLASS =
    'eds-l-pad-vert-4 eds-l-sn-pad-hor-0 eds-l-pad-sm-0';
const FEATURE_INFO_VERTICAL_ALIGNMENT = 'top';

const getTextColor = (color) => `eds-text-color--${color}`;

export const FeatureInfo = ({
    heading,
    description,
    iconType,
    paypalExcl,
    iconColor = DEFAULT_ICON_COLOR,
    textColor = DEFAULT_TEXT_COLOR,
    headingColor,
}) => (
    <section className={FEATURE_INFO_SECTION_CLASS}>
        <ListItem
            iconType={iconType}
            iconColor={iconColor}
            verticalAlignment={FEATURE_INFO_VERTICAL_ALIGNMENT}
        >
            <h1
                className={
                    headingColor
                        ? `${BOLD_TEXT_CLASS} ${getTextColor(headingColor)}`
                        : BOLD_TEXT_CLASS
                }
            >
                {heading}
                {paypalExcl ? <sup>&dagger;</sup> : null}
            </h1>
            <p className={getTextColor(textColor)}>{description}</p>
        </ListItem>
    </section>
);

export const Feature = ({ main, name, shouldShowNewTag }) => {
    const className = classnames('eds-align--center-vertical', {
        [BOLD_TEXT_CLASS]: main,
        [getTextColor(DEFAULT_TEXT_COLOR)]: !main,
        'eds-text-weight--heavy':
            name.__msgid === FEATURE_UNLIMITED_TICKET_TYPES && shouldShowNewTag,
    });

    let newTag = null;
    if (shouldShowNewTag) {
        if (name.__msgid === FEATURE_UNLIMITED_TICKET_TYPES) {
            newTag = (
                <div className="eds-l-mar-left-2">
                    <Badge text={NEW_TAG_TEXT} bgColor="success" />
                </div>
            );
        }
    }

    return (
        <ListItem
            iconType={<CheckChunky />}
            iconStrokeColor={DEFAULT_ICON_COLOR}
        >
            <div className={className}>
                <span>{name}</span>
                <span>{newTag}</span>
            </div>
        </ListItem>
    );
};

export const FeatureInfoSecondaryCTA = ({ text, action }) => (
    <section className={FEATURE_INFO_SECTION_CLASS}>
        <ListItem verticalAlignment={FEATURE_INFO_VERTICAL_ALIGNMENT}>
            <div className="eds-l-mar-left-10">
                <Button style="anchor" onClick={action}>
                    {text}
                    <Icon type={<ArrowRight />} color="ui-blue" />
                </Button>
            </div>
        </ListItem>
    </section>
);
